// extracted by mini-css-extract-plugin
export default {"search":"Search_search__CdWI3","icon":"Search_icon__UbLfO"};